import * as React from 'react'
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'

// Auth
import { Login } from './pages/Login'
import { Confirm } from './pages/Login/Confirm'
import { MagicLinkConfirm } from './pages/Login/MagicLinkConfirm'

import { Privacy } from './pages/Privacy'
import { TermsOfService } from './pages/TermsOfService' 
import { About } from './pages/About'
import { Unsubscribe } from './pages/Unsubscribe'

// In-App
import { AppLayout } from './layouts/App'

import { SuperAdmin } from './pages/SuperAdmin'

// Inboxes
import { Inboxes } from './pages/Inboxes'

// Content
import { Content } from './pages/Content'

// Account
import { Account } from './pages/Account'

// View Folder Sources
import { ViewFolderSources } from './pages/ViewFolderSources'
import { ViewEmailContent } from './pages/ViewEmailContent'

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/confirm',
    element: <Confirm />,
  },
  {
    path: '/magic-link-confirm',
    element: <MagicLinkConfirm />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <TermsOfService />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/unsubscribe',
    element: <Unsubscribe />,
  },
  {
    path: '/app',
    element: <AppLayout />,
    children: [
      {
        path: 'dashboard',
        element: <Inboxes />
      },
      {
        path: 'inboxes',
        element: <Inboxes />
      },
      {
        path: 'folders',
        element: <Inboxes />
      },
      {
        path: 'content',
        element: <Content />
      },
      {
        path: 'super-admin',
        element: <SuperAdmin />
      },
      {
        path: 'account',
        element: <Account />
      },
      {
        path: 'folders/:inboxId/sources',
        element: <ViewFolderSources />
      },
      {
        path: 'folders/:inboxId/emails/:emailId',
        element: <ViewEmailContent />
      }
    ]
  }
])

export const Routes = () => {

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  )
}
